import { DefaultTheme } from 'styled-components';

//? Development
// export const routeConfig = {
//     baseServiceUrl: 'http://localhost:5001',
//     baseHomeUrl: 'https://prispek.co.za'
//     // baseHomeUrl: ''
// };
export const console_log = (msg?: any, ...opt: any[]) =>
    console.log(msg, ...opt);
//? Development
//! Live
export const routeConfig = {
    baseServiceUrl: 'https://prispek.jacodewaal.co.za',
    baseHomeUrl: 'https://prispek.co.za'
};
// export const console_log = (msg?: any, ...opt: any[]) => null;
//! Live

export const Theme: DefaultTheme = {
    primary: '#731116',
    secondary: '#1E7678',
    lightYellow: '#FEE7A6',
    background: '#fefefe',
    text: '#BBB',
    grey: '#ADAC9D',
    cardBack: '#334A6F'
};

export const DateFormats = {
    short: 'D MMM HH:mm',
    full: 'DD/MM/YYYY HH:mm:ss',
    call: 'YYYY-MM-DD HH:mm:ss',
    normal: 'DD-MM-YYYY'
};

export const Bookings = {
    Prisma: 'https://outlook.office365.com/owa/calendar/prisma@prispek.co.za/bookings/',
    Spektra:
        'https://outlook.office365.com/owa/calendar/SPEKTRAMAKELAARS@prispek.co.za/bookings/'
};

export interface returnObjectProps {
    error: string | null;
    success?: any | undefined;
}

export const returnObject: (
    error: string | null,
    success?: any | undefined
) => returnObjectProps = (error, success) => {
    return { error: error, success: success };
};
